// updateServiceWorkStatus.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * update service work status
 * @kind action
 * @param {string} {status} - serviceWorker status.
 * @return {Promise} Action promise.
 */
const updateServiceWorkStatus =
  ({ status }) =>
  async dispatch => {
    const selectPath = ['serviceWorker'];
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        data: {
          status,
        },
        selectPath,
      },
    });
  };

export default updateServiceWorkStatus;
